import React from 'react';
import './homepage.css'
import {  useSelector } from 'react-redux';

import ChatbotTab from "../homepage/ChatbotTab"
import BroadcastTab from "../homepage/BroadcastTab"
import { motion } from "framer-motion"
import { Tabs } from 'antd';

const Homepage = () => {
 
    const selector = useSelector((state) => state.auth)
    const userDetails = JSON.parse(selector?.userInfo)

    const alignValue  = 'center';
    var tabs;
   userDetails?.client.useCase === "Build WhatsApp Chatbot"?
     tabs = [
      {
        key: '1',
        label: 'WhatsApp Chatbot',
        children: <ChatbotTab />,
      },
      {
        key: '2',
        label: 'Broadcast / Survey',
        children:  <BroadcastTab />,
      },
    ] : userDetails?.client.useCase === "Broadcast/Surveys"?
    tabs = [
      {
        key: '1',
        label: 'Broadcast / Survey',
        children:  <BroadcastTab />,
      },
      {
        key: '2',
        label: 'WhatsApp Chatbot',
        children: <ChatbotTab />,
      },
      
    ] :
    tabs = [
      {
        key: '1',
        label: 'WhatsApp Chatbot',
        children: <ChatbotTab />,
      },
      {
        key: '2',
        label: 'Broadcast / Survey',
        children:  <BroadcastTab />,
      },
     
    ];

    const onChange = (key) => {
      // console.log(key);
    };

  return (
    <div className="welcome-page">
      
       <p id="greeting-message">Hello 👋, {userDetails?.firstName + " " + userDetails?.lastName}</p>
       <p className="text-[14px] mb-4">Select either WhatsApp Chatbot to automate conversations or Broadcast / Survey to engage with multiple users at once. Choose the best option based on your use case to get started.</p>
      
      
      <div className="h-max bg-gray-50 rounded-md">
        <div className="max-w-6xl mx-auto px-4 py-2">

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.2 }}
          >
        
        <Tabs
          defaultActiveKey="1"
          items={tabs}
          onChange={onChange}
          indicator={{
            align: alignValue,
          }}
        />
          </motion.div>
        </div>
    </div>

     
    </div>
  )
}

export default Homepage